import React, { useEffect } from "react";
import { TextField } from "@material-ui/core";
import PropTypes from "prop-types";

export default function TPhoto(props) {
  const { answers, getJson } = props;
  const categoryId = 1;
  const type = "TPhoto";

  useEffect(() => {
    if (answers.length <= 0) {
      getJson({ categoryId, type, answers: [{ selected: "" }] });
    }
  }, [answers, getJson]);

  return <TextField disabled type="text" label="Tome una fotografia" />;
}

TPhoto.propTypes = {
  answers: PropTypes.array.isRequired,
  getJson: PropTypes.func,
};
